var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-dialog',{attrs:{"title":"当前点击材质","visible":_vm.dialogVisible,"width":"45%"},on:{"close":_vm.handleClose}},_vm._l((_vm.attrs),function(val,key,i){return _c('p',{key:key},[_vm._v(" "+_vm._s(key)+": "+_vm._s(val)+" ")])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }